module.exports = __webpack_public_path__ + "img/wechat.444f5581.png";